import * as Constants from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case Constants.ITEM_CATALOG_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  case Constants.ITEM_CATALOG_REORDER_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}